import { render } from "./ChatUsers.vue?vue&type=template&id=03fe34e8"
import script from "./ChatUsers.vue?vue&type=script&lang=js"
export * from "./ChatUsers.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Data/2022/cimt2022/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__